import axios from 'axios';
import { API_BASE } from '../config/Api_base';
import api from '../config/axios-conf';

// Dùng plain axios để login — tránh interceptor gắn token cũ vào header
export const loginApi = (data) =>
    axios.post(`${API_BASE}/auth/login`, data, {
        headers: { 'Content-Type': 'application/json' },
    });

export const refreshTokenApi = (refreshToken) =>
    api.post('/auth/refresh', { refreshToken });
